import { portalApiClient, withAuthHeaders } from '@/platform/http'

export const getIdentity = (options?: { authUserIdOverride?: string | number | null }) =>
  portalApiClient.get_user_identity_v2_auth_identity_get(
    withAuthHeaders({
      headers:
        options?.authUserIdOverride == null
          ? {}
          : { 'x-auth-user-id-override': String(options.authUserIdOverride) },
    }),
  )

export const login = getIdentity

export const signUpClient = async ({ email }: { email: string }) => {
  return portalApiClient.client_sign_up_v3_auth_client_sign_up_post({ email }, withAuthHeaders({}))
}

const authRepository = {
  getIdentity,
  login,
  signUpClient,
}

export default authRepository
